import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api, resolveImage } from "@/lib/api";

const SettingsContext = createContext(null);

export const SettingsProvider = ({ children }) => {
  const [settings, setSettings] = useState(null);
  const [loading, setLoading] = useState(true);

  const refresh = useCallback(async () => {
    setLoading(true);
    try {
      const { data } = await api.get("/settings");
      setSettings(data);
      // Update favicon dynamically
      if (data?.site?.favicon) {
        const url = resolveImage(data.site.favicon);
        let link = document.querySelector("link[rel='icon']");
        if (!link) {
          link = document.createElement("link");
          link.rel = "icon";
          document.head.appendChild(link);
        }
        link.href = url;
      }
      if (data?.site?.name) {
        document.title = `${data.site.name} — ${data.site.tagline || "Otorrino"}`;
      }
    } catch (e) {
      console.error("settings load failed", e);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { refresh(); }, [refresh]);

  return (
    <SettingsContext.Provider value={{ settings, loading, refresh, setSettings }}>
      {children}
    </SettingsContext.Provider>
  );
};

export const useSettings = () => useContext(SettingsContext);
